import React from 'react';

import { corporate_landing_path } from '@routes';

const CorporateInquiry = () => {
  return (
    <div className="mx-auto mt-48 border-0 border-t-2 border-solid border-grayscale-10 px-16 pt-16 font-sans text-subtitle-serif font-bold text-primary-black sm:mt-64 sm:px-0 md:max-w-[1040px]">
      Interested in a group or corporate subscription?
      <a href={corporate_landing_path()} className="ml-4 text-primary-red visited:text-primary-red">
        Explore options here
      </a>
    </div>
  );
};

export default CorporateInquiry;
